import {type IGLOBAL} from './IGlobal';

/**
 * Global variable object. It should be avoided importing other then in main.ts or phased
 * out completely in the future through a more robust data structure to allow for better
 * testing and more deterministic code
 * @deprecated New use of globals should be done though the redux
 * store with dispatching changes and subscribing for updates.
 */
export const GLOBAL: IGLOBAL = {
	phpData: null,
	linkedProductsIds: [],
};
